import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, Pipe, PipeTransform } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { SalesBillentryService, CommonService, SubscribeService, ChallanOutService } from '../../../services/index';
import { SalesBillentryModel, ClientModel, EmployeeModel } from '../../../model/index';

@Component({
    selector: 'addeditsalesbillentry-tab',
    templateUrl: './hvphonebill.component.html',
})
export class HVPhoneBillComponent implements OnInit {
    private searchTerms = new Subject<string>();
    private searchTermsEmp = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    //public salesbilltypesdata: any[] = [];

    isLoadMask: Promise<any>;
    //salesbilltypesData: SalesBillentryModel[];
    isLoading: boolean = false;
    minDate: any;

    @Input() salesBillgriddata: SalesBillentryModel[] = [];
    @Input() salesbillentrydata: SalesBillentryModel[] = [];
    potCusCtrl: FormControl;
    store_hvCtrl: FormControl;
    halistCtrl: FormControl;
    serialNoCtrl: FormControl;
    filteredHa: Observable<any[]>;
    filteredSerialNo: Observable<any[]>;
    clientCtrl: FormControl;
    filteredItems: Observable<any[]>;

    @ViewChild('halistAutoComp') halistAutoComp;
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    potCusOptList: any[];
    store_hvOptList: any[];
    haList: any[] = [];
    clientList: any[] = [];
    serialNoList: any[] = [];
    reorderable: boolean = true;
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    columns = [];
    salesBillentryDetails = [];
    totalDetails = [];
    actSerialNoList = [];
    emiDetails = [];
    emplistCtrl: FormControl;
    cliCtrl: FormControl;
    filteredEmp: Observable<any[]>;
    @ViewChild('emplistAutoComp') emplistAutoComp;
    empList: any[] = [];
    clientHVList: any[] = [];
    freeCtrl: FormControl;
    freeList = [];
    constructor(private modalService: BsModalService, private salesBillentryService: SalesBillentryService, private commonService: CommonService, public snackBar: MdSnackBar, public toasterService: ToasterService, public subscribeService: SubscribeService, private challanoutService: ChallanOutService) {

        //this.halistCtrl = new FormControl();
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidFree(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidFree: true };
            }

            return retVal;
        }
        this.freeCtrl = new FormControl('', [
            Validators.required,
            hasValidFree.bind(this)
        ]);
        this.freeList = ['Yes', 'No'];

        function hasValidEmp(input: FormControl) {
            let empid = input.value;
            let femp = _.find(this.empList, { 'empid': empid });
            if (femp)
                return null;
            return { inValidEmp: true };
        }
        this.emplistCtrl = new FormControl('', [
            Validators.required,
            hasValidEmp.bind(this)
        ]);
        //FOR AUTO COMPLETE VALIDATION --- 
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;

            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        function hasValidModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }
        this.clientCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);

        this.filteredHa = this.halistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        this.serialNoCtrl = new FormControl();
        this.filteredSerialNo = this.serialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "CASH" && ledgerID != "CREDIT" && ledgerID != "CARD"
                && ledgerID != "CHEQUE" && ledgerID != "NEFT") {
                retVal = { inValidType: true };
            }

            return retVal;
        }
        this.potCusCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);
        //  this.potCusCtrl = new FormControl();
        this.potCusOptList = ['CASH', 'CREDIT', 'CARD', 'CHEQUE', 'NEFT'];

        // function hasValidType(input: FormControl) { 
        function hasValidStore(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "STORE" && ledgerID != "HV" && ledgerID != "SOA") {
                retVal = { inValidStatus: true };
            }

            return retVal;
        }
        this.store_hvCtrl = new FormControl('', [
            Validators.required,
            hasValidStore.bind(this)
        ]);
        //  this.potCusCtrl = new FormControl();
        this.store_hvOptList = ['STORE', 'HV', 'SOA'];
        //this.clientCtrl = new FormControl();
        //  this.emplistCtrl = new FormControl();
        function hasValidHvClient(input: FormControl) {
            let clientID = input.value;
            let femp = _.find(this.clientHVList, { 'client_id': clientID });
            if (femp)
                return null;
            return { inValidHvClient: true };
        }
        this.cliCtrl = new FormControl('', [
            Validators.required,
            hasValidHvClient.bind(this)
        ]);
        // this.cliCtrl = new FormControl();
    }

    ngOnInit(): void {
        this.salesbillentrydata['tabParams'] = 'HV';
        this._params['tabParams'] = 'HV';
        this._params['mode'] = 'Add';
        this.salesbillentrydata['mode'] = 'Add';
        let that = this;
        this.salesbillentrydata['oldadvances'] = '';
        if (this.salesbillentrydata['tabParams'] != 'HV' && this.salesbillentrydata['tabParams'] != 'SOA') {
            this.loadChallanHaList();
        }

        this.halistAutoComp.optionSelected.subscribe(this.onSelectedHaList.bind(this));

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 85, minWidth: 85, maxWidth: 85, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Free', prop: 'free_item', width: 85, minWidth: 85, maxWidth: 85, sortable: false, cellClass: 'cell-left' },
            { name: 'Model', prop: 'name', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No', prop: 'serial_no', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left' },
            { name: 'MRP', prop: 'mrp', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'Quantity', prop: 'quantity', width: 85, minWidth: 85, maxWidth: 85, sortable: false, cellClass: 'cell-right' },
            { name: 'GST %', prop: 'tax_per', width: 85, minWidth: 85, maxWidth: 85, sortable: false, cellClass: 'cell-right' },
            { name: 'Rate', prop: 'rate', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-right' },
            { name: 'Amount', prop: 'amount', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-right' },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'salesBillentry')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            //.switchMap(term => this.commonService.loadClientList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.salesbillentrydata['date'] = new Date();
            this.salesbillentrydata['amount'] = 0;
            this.salesBillgriddata['amount'] = 0;
        } else {
            this.potCusCtrl.disable();
        }

        this.filteredEmp = this.searchTermsEmp
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.getEmployeeList(term, 'challan')
                // or the observable of empty heroes if there was no search term
                : Observable.of<EmployeeModel[]>([]))
            //.switchMap(term => this.commonService.getEmployeeList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<EmployeeModel[]>([]);
            });

        this.filteredEmp.subscribe(($e) => {
            that.empList = $e;
        });
        setTimeout(() => {
            $('#type').focus();
        }, 100);
        if (this.salesbillentrydata['tabParams'] == 'Advance' || this.salesbillentrydata['tabParams'] == 'EMI') {
            this.potCusOptList = ['CASH', 'CARD', 'CHEQUE'];
        }
        //TO DISABLE SERIAL NO FIELD FOR ADVANCE
        if (this._params['tabParams'] == 'Advance') {
            this.serialNoCtrl.disable();
        }
    }
    ///HV SOA SCREEN
    searchEmployee(query: string) {
        this.searchTermsEmp.next(query);
    }
    onSelectedHVClient(clientID: number) {
        this.onSelectedClient(clientID);
        // if(_.isEmpty(clientID)){
        //     clientID = this.salesbillentrydata['client_id'];
        // }
        let that = this,
            //clientID = clientID,
            empid = that.salesbillentrydata['empid'];
        //   hclhvlist = _.find(this.clientHVList, { 'client_id': clientID });
        // if (!_.isEmpty(hclhvlist)) {
        //     this.salesbillentrydata['client_name'] = hclhvlist.client_name;
        // }
        let data = {
            empid: empid
            //client_id: clientID
        };
        this.salesBillentryService
            .getChalloutModel(data)
            .then(function (res: any) {
                if (res.success) {
                    that.haList = res['haStockModel'];
                    that.actSerialNoList = res['haModelStockSerial'];
                    that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                }
            });
    }
    onSelectedEmp(mdCompEvent: any) {
        let that = this,
            empid = mdCompEvent.empid,
            data = {
                empid: empid
            };
        that.salesbillentrydata['empid'] = empid;

        this.salesBillentryService
            .getExistChalloutClient(data)
            .then(function (res: any) {
                that.clientHVList = res.data;
            });
    }
    displayEmp(empID: number) {
        if (empID && this.empList.length > 0) {
            let femp = _.find(this.empList, { 'empid': empID });
            // this.salesbillentrydata['emp_name'] = femp.empname;
            return femp['empname'];
        } else {
            return '';
        }
    }
    //HV SOA SCREEN
    loadChallanHaList() {
        let that = this,
            data = {
                stock_type: 'HA MODEL',
                from_page: this._params['tabParams']
            };
        this.commonService
            .getHaModelStock(data)
            .then(function (res: any) {
                that.haList = res['haStockModel'];
                that.actSerialNoList = res['haModelStockSerial'];
                that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
            });
    }

    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }

    displayHa(model_id: number) {
        this.serialNoList = [];
        if (model_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'model_id': model_id });
            if (fhalist['stock_type'] == 'Spare' || this._params['tabParams'] == 'Advance') {
                this.serialNoList.push(fhalist);
                this.displaySerialNo(fhalist['serial_no']);
            } else {
                this.getModelSerialNo(model_id); //TO LOAD SERIAL NUMBER FOR THAT MODEL
            }
            return fhalist['name'];
        }
        return '';
    }
    getModelSerialNo(modelID) {
        let actSerialNoList = this.actSerialNoList;
        this.serialNoList = _.filter(actSerialNoList, { 'model_id': modelID });
        this.serialNoCtrl.setValue(this.salesBillgriddata['model_id']);
    }
    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        return this.serialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));
    }

    displaySerialNo(serial_no: number) {
        if (serial_no && this.serialNoList.length > 0) {
            let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no }),
                rate = 0,
                mrp = fhalist.model_mrp;
            if (parseFloat(fhalist.mrp) < parseFloat(fhalist.model_mrp)) {
                mrp = fhalist.mrp;
            }
            this.salesBillgriddata['mrp'] = mrp;
            this.salesBillgriddata['challan_out_id'] = fhalist.challan_out_id;
            this.salesBillgriddata['serial_no'] = fhalist.serial_no;
            this.salesBillgriddata['tax_per'] = fhalist.tax_per;
            this.salesBillgriddata['quantity'] = 1;

            /* if (parseFloat(fhalist.tax_per) > 0) {
                 rate = parseFloat(mrp)*100/(100-  parseFloat(fhalist.tax_per));
             } else {
                 rate = parseFloat(mrp);
             }*/
            if (!_.isEmpty(_.toString(fhalist.tax_per))) {
                rate = ((mrp) * (parseFloat(fhalist.tax_per)) / (100)) + (mrp);
            }
            rate = Math.round(rate);
            //rate = Math.round(rate);
            this.salesBillgriddata['rate'] = rate;
            this.calAmount();

            return fhalist['serial_no'];
        }
        return '';
    }

    onSelectedHaList(mdCompEvent: any) {
        let model_id = mdCompEvent.option.value,
            fhalist = _.find(this.haList, { 'model_id': model_id });

        this.salesBillgriddata['name'] = fhalist.name;
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: this.salesbillentrydata['tabParams'],
                date: moment(this.salesbillentrydata['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.salesbillentrydata['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.salesbillentrydata = Object.assign({}, this._params);
            if (mode == 'Edit') {
                this.getSalesbillentryDetailList();
                this.salesbillentrydata['date'] = new Date(this._params['date']);//new Date();
                this.salesbillentrydata['hidden_client'] = this._params['client_no']; // FOR AUTO COMPLETE ALTERNATE
                if (this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') {
                    this.onSelectedHVClient(this._params['client_id']);
                }
            }
            if (mode == 'View') {
                this.mode = mode;
                this.getSalesbillentryDetailList();
                this.salesbillentrydata['date'] = new Date(this._params['date']);//new Date();
                this.salesbillentrydata['hidden_client'] = this._params['client_no']; // FOR AUTO COMPLETE ALTERNATE
                if (this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') {
                    this.onSelectedHVClient(this._params['client_id']);
                }
            }
        }
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.salesbillentrydata['client_name'] = fitem.client_name; //ANOTHER FIELD
                this.salesbillentrydata['ref_name'] = fitem.name; //ANOTHER FIELD
                return fitem['client_no'];
            }
        }
        return '';
    }
    displayHvSoaFn(client_id: any) {
        if (this.clientHVList != undefined) {
            if (client_id && this.clientHVList.length > 0) {
                let fitem = _.find(this.clientHVList, { 'client_id': client_id });
                return fitem['client_no'];
            }
        }
        return '';
    }

    getSalesbillentryDetailList(): void {
        let that = this,
            mode = this._params['mode'],
            bill_type = this.salesbillentrydata['tabParams'],
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderBy: 'bill_id',
                orderDir: `${this.page.orderDir}`,
                bill_id: this.salesbillentrydata['bill_id'],
                client_id: this.salesbillentrydata['client_id'],
                bill_type: bill_type,
                mode: this._params['mode']
            };
        this.isLoadMask = this.salesBillentryService
            .getSalesbillentryDetailList(params)
            .then(function (res: any) {
                if (res.success) {
                    if (bill_type == 'Advance') {
                        if (res.old_advance != 0) {
                            that.subscribeService.subScribeDeleteActiveTab();
                            swal('WARNING', 'Next Advance Entry Found, so you can not Edit this Advance Bill Details', 'warning');
                            return;
                        }
                    }
                    that.page.count = res.totCnt;
                    that.salesBillentryDetails = res.data;
                    if (bill_type == 'Advance' && mode == 'Edit') {
                        that.salesbillentrydata['oldadvances'] = res.old_advance;
                        that.calGrantTotal('all');
                    } else if (bill_type == 'EMI') {
                        that.emiDetails = res.emiDet;
                    }
                }
            });
    }

    onSelectedClient(mdCompEvent: any) {
        let that = this,
            data = {
                client_id: mdCompEvent.client_id
            };
        if (this.salesbillentrydata['tabParams'] == 'EMI') {
            return;
        }
        this.salesBillentryService
            .getExistAdvClient(data)
            .then(function (res: any) {
                //that.clientList = res;
                if (res.totCnt > 0) {
                    swal({
                        title: 'Previous Advance is Still Pending,you want to Continue?',
                        text: 'Advance Amount: ' + res.data[0].oldadvances,
                        showCancelButton: true,
                        confirmButtonText: 'Yes, Continue!',
                        cancelButtonText: 'No, Cancel'
                    }).then(function () {
                        that.salesbillentrydata['adv_bill_id'] = res.data[0].adv_bill_id;
                        //that.salesbillentrydata['bill_type'] = res.data[0].bill_type;
                        that.salesbillentrydata['bill_id'] = res.data[0].adv_bill_id;

                        // that.salesbillentrydata['discount_percentage'] = res.data[0].discount_percentage;
                        // that.salesbillentrydata['discount_amount'] = res.data[0].discount_amount;
                        that.salesbillentrydata['initial_amount'] = res.data[0].initial_amount;
                        if (that.salesbillentrydata['tabParams'] != "Advance") {
                            that.salesbillentrydata['advances'] = res.data[0].oldadvances;
                        }
                        if (that.salesbillentrydata['tabParams'] == 'Advance') {
                            that.salesbillentrydata['oldadvances'] = res.data[0].oldadvances;
                            that.salesbillentrydata['gross_total'] = res.data[0].gross_total;
                            that.salesbillentrydata['amount'] = res.data[0].amount;
                            that.salesbillentrydata['less_amount'] = res.data[0].less_amount;
                            that.getSalesbillentryDetailList();
                            that.salesbillentrydata['hide_col'] = true;
                        }
                        that.calGrantTotal('all');
                    }, function (dismiss) {
                        if (that.salesbillentrydata['tabParams'] == 'Advance') {
                            that.salesbillentrydata['client_name'] = '';
                            that.salesbillentrydata['client_id'] = '';
                        }
                    });
                }
            });
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(nextEl))) {
            nextEl = 'empid';
        }
        $('#' + nextEl).focus();
    }

    onDeleteSalesbillentry(row: any): void {
        let that = this,
            mode = this._params['mode'];

        if (this.salesbillentrydata['hide_col'] == true) {
            swal('WARNING', 'Previous Advance Bill is in Progress, so You can not Deleted Any Model in this Transaction!');
            return;
        }
        if (mode == 'Add') {
            this.salesBillentryDetails.splice(this.salesBillentryDetails.indexOf(row), 1);
            //this.salesBillgriddata = [];
            this.calGrossTotal();
        } else {
            let params = {
                model_id: row.model_id,
                name: row.name,
                mrp: row.mrp,
                quantity: row.quantity,
                rate: row.rate,
                amount: row.amount,
                bill_id: row.bill_id,
                bill_type: this.salesbillentrydata['tabParams'],
                client_id: this.salesbillentrydata['client_id'],
                challan_out_id: row['challan_out_id'],
                serial_no: row['serial_no']
            };
            swal({
                title: 'Are you sure to Delete?',
                text: 'You will not be able to Recover this Machine Details: ' + row['name'],
                showCancelButton: true,
                confirmButtonText: 'Yes, Delete!',
                cancelButtonText: 'No, Cancel...'
            }).then(function () {
                that.isLoadMask = that.salesBillentryService
                    .deleteGridList(params)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            that.salesBillentryDetails.splice(that.salesBillentryDetails.indexOf(row), 1);
                            swal('SUCCESS', res.message, 'success');
                            if (that.salesbillentrydata['tabParams'] != 'HV' && that.salesbillentrydata['tabParams'] != 'SOA') {
                                that.loadChallanHaList();
                            } else {
                                that.onSelectedHVClient(that.salesbillentrydata['client_id']);
                            }
                            that.getSalesbillentryDetailList();
                            that.calGrossTotal();
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    });
            }, function (dismiss) {
            });
        }
    }

    addSalesbillentry(): void {
        let that = this,
            mode = this.salesbillentrydata['mode'],
            modelID = this.salesBillgriddata['model_id'],
            modelName = this.salesBillgriddata['name'],
            serialNo = this.salesBillgriddata['serial_no'],
            freeItem = this.salesBillgriddata['free_item'];
        if (!_.isEmpty(_.toString(modelID))) {//} != undefined) {
            //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preTestID = _.find(this.salesBillentryDetails, { 'model_id': modelID, 'serial_no': serialNo });

            if (preTestID) {
                swal('WARNING', 'Model : ' + modelName + ', Serial NO: ' + serialNo + ' Already Exists');
                return;
            }
            //TO CHECK STOCK AVAILABLE
            let modelObj = _.find(this.haList, { 'model_id': modelID });
            if (_.isEmpty(modelObj)) {
                swal('WARNING', 'Model : ' + modelName + ' Not Exists');
                return;
            }
            //TO CHECK SERIAL NO EXISTS IN THAT MODEL
            let actSerialNoList = this.actSerialNoList,
                currSerialNoObj = _.find(actSerialNoList, { 'model_id': modelID, 'serial_no': serialNo });
            if (_.isEmpty(currSerialNoObj)) {
                swal('WARNING', 'Serial No : ' + serialNo + ' Does Not Exists in This Model');
                return;
            }

            let availQty = currSerialNoObj['avail_qty'],
                enteredQty = this.salesBillgriddata['quantity'];
            if (_.toNumber(enteredQty) > _.toNumber(availQty)) { // 11 > 10
                swal('WARNING', 'Serial No: ' + serialNo + ' does not have Sufficient Quantity in Stock');
                return;
            }
            if (_.isEmpty(freeItem)) {
                swal('WARNING', 'Select Free Option Yes Or No');
                return;
            }
            if (freeItem != 'No' && this._params['tabParams'] == 'Advance') {
                swal('WARNING', 'In Advance Bill, Free Items can not be Added!');
                return;
            }
            if (this.salesbillentrydata['hide_col'] == true) {
                swal('WARNING', 'Previous Advance Bill is in Progress, so You can not Add Any Model to this Transaction!');
                return;
            }
            if (mode == 'Add') {
                let testDet = Object.assign({}, this.salesBillgriddata);
                this.salesBillentryDetails.push(testDet);
                //this.salesBillgriddata = [];
                this.salesBillgriddata['amount'] = 0;
                that.page.count = this.salesBillentryDetails.length;
                that.calGrossTotal();
                //this.serialNoList = [];
            } else if (mode == 'Edit') {
                let params = {
                    model_id: this.salesBillgriddata['model_id'],
                    name: this.salesBillgriddata['name'],
                    mrp: this.salesBillgriddata['mrp'],
                    rate: this.salesBillgriddata['rate'],
                    quantity: this.salesBillgriddata['quantity'],
                    free_item: this.salesBillgriddata['free_item'],
                    amount: this.salesBillgriddata['amount'],
                    bill_id: this.salesbillentrydata['bill_id'],
                    bill_type: this.salesbillentrydata['bill_type'],
                    client_id: this.salesbillentrydata['client_id'],
                    serial_no: this.salesBillgriddata['serial_no'],
                    challan_out_id: that.salesBillgriddata['challan_out_id'],
                    tax_per: that.salesBillgriddata['tax_per']
                },
                    testDet = Object.assign({}, this.salesBillgriddata);

                this.salesBillentryService
                    .addSalesBillentry(params)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            swal('SUCCESS', res.message, 'success');
                            if (that.salesbillentrydata['tabParams'] != 'HV' && that.salesbillentrydata['tabParams'] != 'SOA') {
                                that.loadChallanHaList();
                            } else {
                                that.onSelectedHVClient(that.salesbillentrydata['client_id']);
                            }
                            that.salesBillentryDetails.push(testDet);
                            that.salesBillgriddata = [];
                            that.salesBillgriddata['amount'] = 0;
                            that.page.count = that.salesBillentryDetails.length;
                            //that.salesBillgriddata = [];
                            //  that.calAmount();
                            that.calGrossTotal();
                            that.getSalesbillentryDetailList();
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    })
            }
        }
    }
    calAmount() {
        let qty = this.salesBillgriddata['quantity'],
            rte = this.salesBillgriddata['rate'],
            amt = 0;

        if (!_.isEmpty(_.toString(rte))) {
            amt = (qty * rte);
        }
        this.salesBillgriddata['amount'] = amt;
    }
    calGrossTotal() {
        let gross_total = 0,
            free_amt = 0,
            free = '';

        for (let i = 0; i < this.salesBillentryDetails.length; i++) {
            let amount = this.salesBillentryDetails[i].amount;
            let free_item = this.salesBillentryDetails[i].free_item;
            gross_total += Number(amount);
            free = free_item;
            if (free == 'Yes')
                free_amt += amount;

        }
        this.salesbillentrydata['gross_total'] = gross_total;
        //this.salesbillentrydata['free_item'] = free;
        this.salesbillentrydata['less_amount'] = free_amt;
        this.calGrantTotal('all');
    }

    calGrantTotal(from_field) {

        let gross_total = this.salesbillentrydata['gross_total'],
            dis_per = this.salesbillentrydata['discount_percentage'],
            advances = this.salesbillentrydata['advances'],
            initial_amount = this.salesbillentrydata['initial_amount'],
            oldadvances = this.salesbillentrydata['oldadvances'],
            //free = this.salesbillentrydata['free_item'],
            less = this.salesbillentrydata['less_amount'],
            discount_amount = this.salesbillentrydata['discount_amount'],
            grant_total = 0,
            gstotal = 0,
            total = 0;


        // if(from_field == 'dis_per'){
        //     //this.salesbillentrydata['discount_amount'] = 0;
        //     discount_amount = 0;
        // } else if(from_field == 'dis_amt'){
        //     //this.salesbillentrydata['discount_percentage'] = 0;
        //     dis_per = 0;
        // }

        if (_.isEmpty(_.toString(gross_total))) {
            gross_total = 0;
        }
        if (!_.isEmpty(_.toString(dis_per))) {
            if (dis_per >= 0 && from_field == 'dis_per') {
                this.salesbillentrydata['discount_amount'] = 0;
                discount_amount = (gross_total * dis_per) / 100;

            }
        } else {
            dis_per = 0;
            discount_amount = 0;
        }
        if (!_.isEmpty(_.toString(discount_amount)) && discount_amount != 0) {
            if (from_field == 'dis_amt')
                this.salesbillentrydata['discount_percentage'] = 0;//(parseFloat(discount_amount) / parseFloat(gross_total)) * 100;
            dis_per = (discount_amount / gross_total) * 100;
            dis_per = (dis_per.toFixed(2)) / 1;

        } else {
            discount_amount = 0;
            dis_per = 0;
        }

        if (_.isEmpty(_.toString(advances))) {
            advances = 0;
        }
        if (_.isEmpty(_.toString(initial_amount))) {
            initial_amount = 0;
        }
        if (_.isEmpty(_.toString(oldadvances)) || this.salesbillentrydata['tabParams'] == "Sales Bill") {
            oldadvances = 0;
        }
        if (advances == undefined) {
            advances = 0;
        }
        if (oldadvances == undefined) {
            advances = 0;
        }
        if (_.isEmpty(_.toString(less))) {
            less = 0;
        }

        total = parseFloat(discount_amount);
        total = total + parseFloat(less);
        total = total + parseFloat(advances);
        total = total + parseFloat(oldadvances);
        total = total + parseFloat(initial_amount);
        gstotal = parseFloat(gross_total);
        grant_total = gstotal - total;

        //grant_total = (parseFloat(gross_total) - parseFloat(discount_amount + less)) - (parseFloat(advances) + parseFloat(oldadvances) + parseFloat(initial_amount));


        // if (!_.isEmpty(_.toString(gross_total))) {
        //     grant_total = gross_total - discount_amount;
        // }
        // if (!_.isEmpty(_.toString(advances))) {
        //     grant_total = (gross_total - discount_amount) - advances;
        // }
        this.salesbillentrydata['discount_percentage'] = dis_per;
        this.salesbillentrydata['discount_amount'] = discount_amount;
        this.salesbillentrydata['less_amount'] = less;
        this.salesbillentrydata['amount'] = grant_total;
    }
    bsModalRef: BsModalRef;
    onSaveSalesbillentry(): void {
        let that = this,
            mode = this.salesbillentrydata['mode'],
            advance = this.salesbillentrydata['advances'],
            initial_amount = this.salesbillentrydata['initial_amount'],
            salesBillentry = this.salesBillentryDetails.length,
            qty = 0;
        if (_.isEmpty(_.toString(this.salesbillentrydata['client_id']))) {
            swal('WARNING', 'Please Select Client ID');
            return;
        }
        if (this.salesbillentrydata['amount'] < 0) {
            swal('WARNING', 'Please Enter Valid Amount');
            return;
        }
        if (this.salesbillentrydata['tabParams'] == 'Advance') {
            if (_.isEmpty(_.toString(advance))) {
                swal('WARNING', 'Please Enter Advance Amount');
                return;
            } else if (advance <= 0) {
                swal('WARNING', 'Please Enter Valid Advance Amount');
                return;
            }
        }
        if (this.salesbillentrydata['tabParams'] == 'EMI') {
            if (_.isEmpty(_.toString(initial_amount))) {
                swal('WARNING', 'Please Enter Initial Amount');
                return;
            } else if (initial_amount <= 0) {
                swal('WARNING', 'Please Enter Valid Initial Amount');
                return;
            }
        }
        if (_.isEmpty(_.toString(this.salesbillentrydata['type']))) {
            swal('WARNING', 'Please Select Type');
            return;
        }
        if (salesBillentry == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Model Details');
            return;
        }
        for (let i = 0; i < salesBillentry; i++) {
            qty += this.salesBillentryDetails[i].quantity;
        }
        let salesBillentryDate = moment(this.salesbillentrydata['date']).format('YYYY-MM-DD'),
            data = {
                bill_id: this.salesbillentrydata['bill_id'],
                auto_no: this.salesbillentrydata['auto_no'],
                date: salesBillentryDate,
                from_type: this.salesbillentrydata['from_type'],
                type: this.salesbillentrydata['type'],
                client_id: this.salesbillentrydata['client_id'],
                client_name: this.salesbillentrydata['client_name'],
                salesBillentryDetails: JSON.stringify(this.salesBillentryDetails),
                gross_total: this.salesbillentrydata['gross_total'],
                discount_percentage: this.salesbillentrydata['discount_percentage'],
                discount_amount: this.salesbillentrydata['discount_amount'],
                description: this.salesbillentrydata['description'],
                amount: this.salesbillentrydata['amount'],
                less_amount: this.salesbillentrydata['less_amount'],
                advances: advance,
                initial_amount: initial_amount,
                mode: this.salesbillentrydata['mode'],
                bill_type: this.salesbillentrydata['tabParams'],
                adv_bill_id: that.salesbillentrydata['adv_bill_id'],
                emiDetails: [],
                empid: that.salesbillentrydata['empid'],
                tot_qty: qty,
                chqno: this.salesbillentrydata['chqno'],
                bank: this.salesbillentrydata['bank'],
                gst: this.salesBillentryDetails['tax_per']
            };

        that.isLoading = true;
        this.salesBillentryService
            .addUpdatesalesBillentry(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.salesbillentrydata = [];
                    that.salesBillentryDetails = [];
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadSalesBillentryListGrid();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/hvphonebill/hvphonebill.component.ts